<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 888"
    :fileAdd="checkData.image.length <= 12"
    :files="checkData.image"
    :delete-files="checkData.deleteFiles"
    maxFiles="3"
    maxFilesShow="3"
    :on-save="onSave"
  >
    <v-form
      class="d-grid gap-5"
      :class="{ 'grid-col-sm-1-1 grid-col-md-1-1-1': !modal }"
      ref="form"
      lazy-validation
    >
      <BaseInput
        :label="
          localStorage.translations.pages['setting-personal_area'].labels[
            'verhniy-uroven-zarobotnoy-platy'
          ]
        "
        v-model="checkData.upper_wage_level"
        append-outer-icon="euro"
        input-type="Number"
        :view="!editing"
        :view-value="(checkData.upper_wage_level || '-') + ' €'"
      />
      <BaseInput
        :label="localStorage.translations.pages['setting-personal_area'].labels['nizhniy-protsent']"
        v-model="checkData.lower_percentage"
        append-outer-icon="mdi-percent-outline"
        input-type="Number"
        :view="!editing"
        :view-value="(checkData.lower_percentage || '-') + ' %'"
      />
      <BaseInput
        :label="localStorage.translations.pages['setting-personal_area'].labels['verhniy-protsent']"
        v-model="checkData.top_percentage"
        append-outer-icon="mdi-percent-outline"
        input-type="Number"
        :view="!editing"
        :view-value="(checkData.top_percentage || '-') + ' %'"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'TaxCard',
  props: { editing: Boolean, tax_card: Object, userId: Number, onSave: Function, modal: Boolean },
  components: {
    PersonalAreaTemplate,
  },
  data: () => ({
    taxCardData: null,
    checkData: {
      upper_wage_level: null,
      lower_percentage: null,
      top_percentage: null,
      image: [],
      deleteFiles: [],
    },
  }),
  watch: {
    tax_card() {
      if (this.tax_card) {
        this.taxCardData = JSON.parse(this.tax_card.data)
      }
    },
    taxCardData() {
      if (this.taxCardData) {
        this.checkData.upper_wage_level = this.taxCardData.upper_wage_level
        this.checkData.lower_percentage = this.taxCardData.lower_percentage
        this.checkData.top_percentage = this.taxCardData.top_percentage
        if (this.taxCardData.image !== undefined) {
          this.checkData.image = this.taxCardData.image
        }
      }
      this.onNavigationGuardianCheck({
        data: { taxCard: this.checkData },
        overwrite: true,
      })
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { taxCard: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  mounted() {
    if (this.tax_card && !this.taxCardData) {
      this.taxCardData = JSON.parse(this.tax_card.data)
    }
  },
  computed: {
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
        this.checkData.deleteFiles = []
      }
    },
    async submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: file.type === 'application/pdf' ? null : 'cover',
          })
          .then((response) => {
            this.checkData.image[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.checkData.image.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('taxCard')) {
          await Promise.all(
            this.checkData.image.map(async (file, index) => {
              if (typeof file !== 'string') {
                await this.submitFile(file, index)
              }
            }),
          )
          await this.deleteImageBD()
          let data = {
            type: 'tax_card',
            data: JSON.stringify({
              upper_wage_level: this.checkData.upper_wage_level,
              lower_percentage: this.checkData.lower_percentage,
              top_percentage: this.checkData.top_percentage,
              image: this.checkData.image,
            }),
          }
          if (!this.tax_card) {
            if (this.$route.name === 'PersonalAreaEmployeeEdit') {
              data.user_id = this.userId
            }
          } else {
            data.id = this.tax_card.id
          }
          resolve(data)
        }
        resolve(true)
      })
    },
  },
}
</script>
